
export default class BlockFiftyFiftyContent {
    
    constructor(container, options) {
        const defaultOptions = {
            scrollContainer: '.scroll-container',
            arrowsContainer: '.arrows',
            downButton: '.down',
            upButton: '.up',
            scrollSpeed: 120
        };

        this.options = Object.assign({}, defaultOptions, options);

        this.container = document.querySelector(container);
        this.downButton = this.container.querySelector(this.options.downButton);
        this.upButton = this.container.querySelector(this.options.upButton);
        this.scrollContainer = this.container.querySelector(this.options.scrollContainer);
        this.arrowsContainer = this.container.querySelector(this.options.arrowsContainer);        

        this.init();
    }

    init(){
      
        this.downButton
            .addEventListener('mousedown', (e) => this.scrollDown(e));
        this.downButton
            .addEventListener('mouseup', (e) => this.stopScrolling(e));
            
        this.upButton
            .addEventListener('mousedown', (e) => this.scrollUp(e));            
        this.upButton
            .addEventListener('mouseup', (e) => this.stopScrolling(e));

        this.scrollContainer
            .addEventListener('scroll', (e) => this.scrollChanged(e));

        if(this.scrollContainer.offsetHeight === this.scrollContainer.scrollHeight){           
            this.arrowsContainer.style.display = 'none';
            this.scrollContainer.style.overflowY = 'auto';
        }

    }

    scrollChanged(e){

        const elem = e.target;
        
        const reachEnd = (elem.scrollTop + elem.offsetHeight) >= (elem.scrollHeight - 1);        
        const reachStart = elem.scrollTop === 0;

        if(reachStart){
            this.upButton.classList.add("hidden");
            this.downButton.classList.remove("hidden");
        }
        else if (reachEnd){
            this.upButton.classList.remove("hidden");
            this.downButton.classList.add("hidden");
        }
        else{
            this.upButton.classList.remove("hidden");
            this.downButton.classList.remove("hidden");
        }

    }

    scrollDown(){
           
        this.scrollContainer.scrollTo({
            top: this.scrollContainer.scrollHeight,
            left: 0,
            behavior: "smooth"

        });

    }

    scrollUp(){

        this.scrollContainer.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"

        });
    }

    stopScrolling(){
        this.scrollContainer.scrollTop = this.scrollContainer.scrollTop;
    }
}